import React, { PureComponent } from 'react'

import { withTranslation } from '@hocs'

import PlacePostContainer from '../PlacePostContainer'

import MasonryVirtualized from '@components/MasonryVirtualized'

import styles from './PlacePosts.scss'

class PlacePosts extends PureComponent {
  _handleRenderCell = (index) => {
    const id = this.props.displayPostIds.get(index)
    return <PlacePostContainer postId={id} />
  }

  _handleInfiniteScroll = () => this.props.getPlacePosts()

  render() {
    const { displayPostIds, hasMorePosts, t } = this.props
    return (
      <div className="place__posts posts">
        <style jsx>{styles}</style>
        <div className="posts__header">{t('發文打卡，你也會在這出現喔！')}</div>
        <div className="posts__grid">
          <MasonryVirtualized
            hasMore={hasMorePosts}
            cells={displayPostIds}
            columns={[null, 0]}
            initInfiniteScroll={false}
            handleRenderCell={this._handleRenderCell}
            handleInfiniteScroll={this._handleInfiniteScroll}
          />
        </div>
      </div>
    )
  }
}

export default withTranslation()(PlacePosts)
